import useGetProductReviewRatings from './useGetProductReviewRatings';

export default useGetProductReviewRatings;
